module.exports = __webpack_public_path__ + "static/media/babyCarriage.16b9d1cf.svg";